import { PlusIcon, StorageIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import { DialogTrigger } from "@/components/ui/dialog";

interface EmptyStateProps {
  title?: string;
  description?: string;
  buttonText?: string;
  testId?: string;
  isCreateDatasetGranted?: boolean;
  tourId?: string;
  buttonTourId?: string;
}

/**
 * Empty state component for when no datasets are available
 */
export default function EmptyState({
  title = "No Datasets Available",
  description = "Upload a dataset to get started.",
  buttonText = "Upload Dataset",
  testId = "no-dataset-state",
  isCreateDatasetGranted = true,
  tourId,
  buttonTourId
}: Readonly<EmptyStateProps>) {
  return (
    <div
      className="flex flex-col items-center justify-center h-full text-center text-sm text-dim-gray my-auto"
      data-testid={testId}
    >
      <div
        data-tourid={tourId}
        className="flex flex-col items-center justify-center w-fit h-fit"
      >
        <StorageIcon className="fill-light-gray w-8 h-8" />
        <p className="text-txtPlaceholder text-sm font-semibold">{title}</p>
        <p className="text-txtPlaceholder text-xs">{description}</p>

        {isCreateDatasetGranted && (
          <DialogTrigger asChild data-testid="no-dataset-upload-button">
            <Button
              variant="default"
              className="font-semibold rounded-xl my-4"
              data-tourid={buttonTourId}
            >
              <PlusIcon className="w-4 h-4 mr-2 fill-txtBody" />
              {buttonText}
            </Button>
          </DialogTrigger>
        )}
      </div>
    </div>
  );
}
